module.exports = __webpack_public_path__ + "img/illustration-sans-fil-01.b7c1911c.png";